import { c as _c } from "react/compiler-runtime";
import { Container, FlexColumn, Media, Separator } from "@opensea/ui-kit";
import { headerViewCompactVariants } from "@/components/hero-header/constants";
import { HeroHeaderFullLayoutSkeleton } from "@/components/hero-header/HeroHeaderFullLayoutSkeleton";
import { CollectionInfoSkeleton } from "./CollectionInfoSkeleton";
import { CollectionMetadataChipsSkeleton } from "./CollectionMetadataChipsSkeleton";
import { CollectionStatsSkeleton } from "./CollectionStatsSkeleton";
export function CollectionHeaderFullContentSkeleton() {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <CollectionInfoSkeleton headerView="full" />;
    t1 = <CollectionMetadataChipsSkeleton />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <HeroHeaderFullLayoutSkeleton info={t0} metadataChips={t1} showMetadataChipsOnLarge={false} stats={<CollectionStatsSkeleton />} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
export function CollectionHeaderCompactContentSkeleton() {
  const $ = _c(6);
  let T0;
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    const {
      container,
      content
    } = headerViewCompactVariants();
    T0 = Container;
    t1 = container();
    t0 = content();
    t2 = <CollectionInfoSkeleton headerView="compact" variant="default" />;
    $[0] = T0;
    $[1] = t0;
    $[2] = t1;
    $[3] = t2;
  } else {
    T0 = $[0];
    t0 = $[1];
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Media lessThan="md"><CollectionMetadataChipsSkeleton className="mt-4" variant="default" /></Media>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <T0 className={t1}><div className={t0}>{t2}<FlexColumn className="shrink-0 lg:flex-row lg:justify-end">{t3}<Media lessThan="lg"><Separator className="my-4" /></Media><CollectionStatsSkeleton variant="default" /></FlexColumn></div></T0>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}